// Sidebar navigation map for the employer admin portal. `story` cross-
// references the user story it implements in BrandonUserStoryAPI.md
// (EMP-01 through EMP-04), same convention as the ICIB admin console.
export const NAV = [
  {
    section: 'Register',
    items: [
      { path: '', label: 'Overview', story: '' },
      { path: 'employees', label: 'Employees', story: 'EMP-01' },
    ],
  },
  {
    section: 'Movements',
    items: [
      { path: 'new-starter', label: 'Add Employee', story: 'EMP-03' },
      { path: 'pending-intake', label: 'Pending enrolment', story: 'ICIB-13' },
      { path: 'outstanding', label: 'Enrolment status', story: 'EMP-02' },
      { path: 'leavers', label: 'Remove Employee', story: 'EMP-04' },
    ],
  },
];
